import React from 'react';
import type { TopCampaign } from '@troia-v3/types';

import { DashCard, DeltaBadge, formatBRLShort, formatNumber, formatPct } from '@/shared/components/ui';

interface TopCampaignsCardProps {
  campaigns: TopCampaign[];
}

export const TopCampaignsCard: React.FC<TopCampaignsCardProps> = ({ campaigns }) => {
  return (
    <DashCard
      icon="megaphone"
      title="Top campanhas"
      subtitle="Receita ganha por campanha"
      testId="top-campaigns-card"
    >
      <div className="flex flex-col">
        {campaigns.length === 0 && (
          <div className="py-4 text-center text-xs" style={{ color: 'var(--theme-muted-text)' }}>
            Nenhuma campanha com vendas no período.
          </div>
        )}
        {campaigns.map((c, idx) => (
          <div
            key={c.campaignName}
            className="flex items-center gap-3 py-3"
            style={{ borderTop: idx > 0 ? '1px solid var(--theme-card-border)' : 'none' }}
            data-testid={`top-campaign-${idx}`}
          >
            <span
              className="text-sm font-bold w-5 text-center flex-shrink-0"
              style={{ color: 'var(--theme-muted-text)', fontVariantNumeric: 'tabular-nums' }}
            >
              {idx + 1}
            </span>
            <div className="flex-1 min-w-0">
              <div className="text-sm font-semibold truncate" style={{ color: 'var(--theme-card-text)' }}>
                {c.campaignName}
              </div>
              <div className="text-[11px]" style={{ color: 'var(--theme-muted-text)' }}>
                {formatNumber(c.leads)} leads · {formatNumber(c.won)} fechados · conv. {formatPct(c.conversionRate)}
              </div>
            </div>
            <div className="flex flex-col items-end gap-1 flex-shrink-0">
              <div
                className="text-sm font-bold"
                style={{ color: 'var(--theme-card-text)', fontVariantNumeric: 'tabular-nums' }}
              >
                {formatBRLShort(c.revenue)}
              </div>
              {c.deltaPct !== 0 && <DeltaBadge deltaPct={c.deltaPct} />}
            </div>
          </div>
        ))}
      </div>
    </DashCard>
  );
};

TopCampaignsCard.displayName = 'TopCampaignsCard';
